import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


export class NewFactuurData {
  factuurnummer: number;
}


@Component({
  selector: 'app-new-factuur',
  templateUrl: './new-factuur.component.html',
  styleUrls: ['./new-factuur.component.less']
})
export class NewFactuurComponent implements OnInit {


  public data = new NewFactuurData();

  constructor(
    public dialogRef: MatDialogRef<NewFactuurComponent>,
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
